import React, { useState, useEffect } from 'react';
import "./CarFormPage.css";
import { useNavigate } from "react-router-dom";
import config from '../config/config';

const CarFormPage = ({ marka, model, year, texPassport, carNumber, onClose }) => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        brand: marka || '',
        model: model || '',
        year: year || '',
        mileage: '',
        phone: '',
        texPassport: texPassport || '',
        carNumber: carNumber || ''
    });

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            brand: marka || '',
            model: model || '',
            year: year || '',
            texPassport: texPassport || '',
            carNumber: carNumber || ''
        }));
    }, [marka, model, year, texPassport, carNumber]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (name === "texPassport" || name === "carNumber") {
            newValue = value.toUpperCase();
        }

        setFormData(prev => ({ ...prev, [name]: newValue }));
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        if (!value.startsWith("998")) {
            value = "998" + value;
        }
        value = value.slice(0, 12);
        setFormData(prev => ({ ...prev, phone: "+" + value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.brand || !formData.model || !formData.year ||
            !formData.phone || !formData.texPassport || !formData.carNumber) {
            alert('❗ Пожалуйста, заполните все поля.');
            return;
        }

        try {
            const response = await fetch(`${config.apiUrl2}/api/orders/create-order-manual`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error('Ошибка при отправке данных');
            }

            alert('✅ Данные успешно отправлены!');
            setFormData({
                brand: '',
                model: '',
                year: '',
                mileage: '',
                phone: '',
                texPassport: '',
                carNumber: ''
            });

            if (onClose) onClose();
            navigate('/');
        } catch (error) {
            console.error('❌ Ошибка:', error);
            alert('Произошла ошибка при отправке данных.');
        }
    };

    return (
        <div
          style={{ maxWidth: '440px', margin: 'auto', position: 'relative' }}>

            {/* Кнопка закрытия */}
            <button
                type="button"
                onClick={onClose}
                style={{
                    position: "absolute",
                    top: "-24px",
                    right: "-22px",
                    background: "transparent",
                    border: "none",
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "#ff0000",
                    transition: "color 0.2s ease",
                }}
                onMouseOver={(e) => (e.target.style.color = "#d9534f")}
                onMouseOut={(e) => (e.target.style.color = "#555")}
            >
                ✖
            </button>

            <h2
                style={{
                    textAlign: "center",
                    marginBottom: "20px",
                    fontSize: "1.5rem",
                    color: "#333",
                }}
            >
                🚗 Заполните данные    об автомобиле
            </h2>

            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="brand"
                    placeholder="Марка автомобиля"
                    value={formData.brand}
                    onChange={handleChange}
                />
                <br />
                <input
                    type="text"
                    name="model"
                    placeholder="Модель автомобиля"
                    value={formData.model}
                    onChange={handleChange}
                />
                <br />
                <input
                    type="number"
                    name="year"
                    placeholder="Год производства"
                    value={formData.year}
                    onChange={handleChange}
                />
                <br />
                <input
                    type="text"
                    name="texPassport"
                    placeholder="Техпаспорт"
                    value={formData.texPassport}
                    onChange={handleChange}
                />
                <br />
                <input
                    type="text"
                    name="carNumber"
                    placeholder="Госномер"
                    value={formData.carNumber}
                    onChange={handleChange}
                />
                <br />
                <input
                    type="text"
                    name="phone"
                    placeholder="+998 __ ___ __ __"
                    value={formData.phone}
                    onChange={handlePhoneChange}
                />
                <br />
                <button type="submit">Отправить</button>
            </form>
        </div>
    );
};

export default CarFormPage;
